<template>
  <UIButton
    href="#main-content"
    tabindex="1"
    variant="primary"
    class="skip-link"
  >
    Skip To Main Content
  </UIButton>
</template>

<style lang="scss" scoped>
.skip-link {
  @apply absolute -left-[99999px] top-0 opacity-0;
  @apply focus:left-10 focus:top-2 focus:inline-flex focus:z-[10000] focus:opacity-100;
}
</style>
